import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumnBreak24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextColumnBreak24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.5 4.236a.75.75 0 0 1-.736.764c-.502.01-.865.01-1.264.008V19.25c0 .69-.56 1.25-1.25 1.25h-1.5a.75.75 0 0 1 0-1.5H11V4.757c0-.698.57-1.258 1.264-1.25.495.004.884.004 1.472-.007a.75.75 0 0 1 .764.736M2.75 6.5a.75.75 0 0 0 0 1.5H7.5a.75.75 0 1 0 0-1.5zm.003 6a.75.75 0 0 0-.006 1.5l4.75.016a.75.75 0 0 0 .006-1.5zM2 10.25a.75.75 0 0 1 .75-.75H6A.75.75 0 0 1 6 11H2.75a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5H6a.75.75 0 0 0 0-1.5zm13-8.25a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 0 1.5H16.5a.75.75 0 0 1-.75-.75m0 5.998a.75.75 0 0 1 .753-.748l4.75.016a.75.75 0 0 1-.006 1.5L16.498 14a.75.75 0 0 1-.747-.752M16.5 9.5a.75.75 0 0 0 0 1.5h3.25a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h3.25a.75.75 0 0 1 0 1.5H16.5a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumnBreak24);
